module.exports = __webpack_public_path__ + "static/img/dataStatistics.751e492c.png";